<template>
  <Header></Header>
  <SideBar></SideBar>

  <Body pageTitle="General Statistic">
    <template v-slot:body>
      <div class="app-inner-layout chat-layout" ref="container">
        <div class="row filter-form d-flex flex-wrap mb-5 clearfix">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div class="actions d-flex flex-wrap flex-auto tablenav">
                  <DatePicker v-model="query.date" range multi-calendars format="YYYY-MM-DD" class="m-1 date-picker-left" placeholder="Date Range" style="max-width: 250px" />
                  <Select class="mr-2" source="sale-account/search" placeholder="Sale Account" v-model="query.account_id"></Select>
                  <Select class="mr-2" source="user/search" type="auto" field="order.user_read" placeholder="Seller" v-model="query.user_id"></Select>
                  <button class="btn btn-light" @click.prevent="submit">Search</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="content-wrap">
          <TotalSale :config="data" />
          <SaleOrder :config="data" />
          <Chart :config="data" />
          <BestSelling :config="data" />
          <TopSeller :config="data" />
        </div>
      </div>
    </template>
  </Body>
</template>

<script>
import Event from '@/helper/event.js'
import Header from '@/layouts/Header.vue'
import SideBar from '@/layouts/SideBar.vue'
import Body from '@/layouts/Body.vue'
import Select from '@/components/Select.vue'
import TotalSale from './TotalSale.vue'
import SaleOrder from './SaleOrder.vue'
import Chart from './Chart.vue'
import BestSelling from './BestSelling.vue'
import TopSeller from './TopSeller.vue'
import DatePicker from '@/components/DatePicker.vue'
export default {
  components: {
    Header,
    SideBar,
    Body,
    Select,
    TotalSale,
    SaleOrder,
    Chart,
    BestSelling,
    TopSeller,
    DatePicker
  },
  mixins: [Event],
  data() {
    return {
      query: {
        account_id: null,
        user_id: null,
        date: [new Date(), new Date()]
      }
    }
  },
  computed: {
    storeId() {
      return 'main'
    },
    getUri() {
      return `order/statistic-preliminary`
    },
    data() {
      return Object.assign(
        {
          total_sale: {}
        },
        this.store.getter('')
      )
    }
  },
  methods: {
    setUpData(rawData) {
      if (rawData.status != 'success') return
      this.store.commit('', rawData.data)
    },
    submit() {
      this.fetchData(this.query, {
        $el: this.$refs.container
      })
    }
  }
}
</script>
<style lang="scss">
.page-order-statistic-preliminary {
  .tablenav {
    input {
      max-width: 170px;
    }
  }
  .multiselect {
    width: 170px;
  }
  .best-selling-product {
    .widget-content-wrapper {
      min-height: 44px;
    }
  }
}
</style>
